export function isMobile(): boolean {
    if (typeof window === "undefined") {
        return false;
    }

    const userAgentCheck = /android|iphone|ipad|ipod|opera mini|iemobile|wpdesktop/i.test(
        navigator.userAgent
    );

    return userAgentCheck;
}